// extracted by mini-css-extract-plugin
export default {"title":"wIqqCb","description":"loqJ4R","list":"tARy_m","item":"Oz0ZHQ"};